import React, { MutableRefObject, useEffect, useRef } from 'react';
import {SelfieSegmentation} from "@mediapipe/selfie_segmentation"
import Model from "@mediapipe/selfie_segmentation"

function App() {
  const canvasRef: MutableRefObject<HTMLCanvasElement  | undefined> = useRef();
  const videoRef: MutableRefObject<HTMLVideoElement  | undefined> = useRef();
  const created : MutableRefObject<boolean | undefined> = useRef();
  useEffect(() => {
    let prevFilterList : any[] = [];
    if(!created.current){
      created.current = true;
      const selfieSegmentation = new SelfieSegmentation({locateFile: (file) => {
        return `https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/${file}`;
      }});
      selfieSegmentation.onResults((results) => {
        const c = canvasRef.current;
        if(!c) return;
        const ctx = c.getContext('2d')!;
        ctx.globalCompositeOperation = "source-over"
        ctx.clearRect(0, 0, c.width, c.height);
        // Draw the original image
        ctx.drawImage(results.segmentationMask, 0, 0, c.width, c.height);
        prevFilterList.forEach(prevFilter => {
          ctx.drawImage(prevFilter, 0, 0, c.width, c.height);
        })
        // ctx.clearRect(0, 0, c.width, c.height);
        // ctx.drawImage(results.image, 0, 0, c.width, c.height);
        // Draw the segmentation mask
        ctx.globalCompositeOperation = 'source-in';
        ctx.fillStyle = '#ff0000';
        ctx.drawImage(results.image, 0, 0, c.width, c.height);
        prevFilterList.unshift(results.segmentationMask)
        while ( prevFilterList.length > 10 ){
          prevFilterList.pop()
        }
      })
      selfieSegmentation.setOptions({ modelSelection: 1, });
      navigator.mediaDevices .getUserMedia({audio: false, video: {facingMode: "user"}})
        .then((media_stream) => {
          const video = videoRef.current;
          if(!video) return;
          video.srcObject = media_stream;
          const playing = async () => {
            await selfieSegmentation.send({image: video});
            // setTimeout(playing, 30)
            window.requestAnimationFrame(playing)
          } 
          video.onplay = playing
          video.play();
        })
    .catch((e) => {console.error("Unable to start webcam", e);});
      // console.log("###", Mediapipe)
    }
  },[])
  return (
    <>
      <video ref={videoRef as any} className='hidden absolute w-full h-full'></video>
      <canvas ref={canvasRef as any} className='w-full h-full bg-transparent'>
      {/* <canvas ref={canvasRef as any} className='w-full h-full bg-purple'> */}
      </canvas>
    </>
  );
}

export default App;
